import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class DrawChartService extends Subject<void> {}
